import { storableError } from '../../util/errors';
import { paymentsSummaryAPI, paymentsSyncLedgerAPI } from '../../util/api';

export const FETCH_SUMMARY_REQUEST = 'app/HostPaymentsPage/FETCH_SUMMARY_REQUEST';
export const FETCH_SUMMARY_SUCCESS = 'app/HostPaymentsPage/FETCH_SUMMARY_SUCCESS';
export const FETCH_SUMMARY_ERROR = 'app/HostPaymentsPage/FETCH_SUMMARY_ERROR';

const initialState = {
  fetchInProgress: false,
  fetchError: null,
  summary: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_SUMMARY_REQUEST:
      return { ...state, fetchInProgress: true, fetchError: null };
    case FETCH_SUMMARY_SUCCESS:
      return { ...state, fetchInProgress: false, summary: payload };
    case FETCH_SUMMARY_ERROR:
      return { ...state, fetchInProgress: false, fetchError: payload };
    default:
      return state;
  }
}

const fetchRequest = () => ({ type: FETCH_SUMMARY_REQUEST });
const fetchSuccess = payload => ({ type: FETCH_SUMMARY_SUCCESS, payload });
const fetchError = e => ({ type: FETCH_SUMMARY_ERROR, error: true, payload: e });

// loadData: kick off a server-side ledger sync first (idempotent — backfills
// any transactions completed since the last visit), then read the authoritative
// summary. If the sync fails we still try to read the existing summary; the
// page is still useful with stale data.
export const loadData = () => async dispatch => {
  dispatch(fetchRequest());
  try {
    await paymentsSyncLedgerAPI().catch(() => null);
    const summary = await paymentsSummaryAPI();
    dispatch(fetchSuccess(summary));
    return summary;
  } catch (e) {
    dispatch(fetchError(storableError(e)));
    throw e;
  }
};
